module.exports = __webpack_public_path__ + "img/horizontal_7_4_3016.4ca8f45c.png";